import React from 'react'
import type { Icon } from 'shared/utils'

const FidelityCard = (props: Icon) => {
    const {
        color = 'black',
        width = 24,
        height = 24,
        className = 'fidelity-card'
    } = props
    return (
        <svg width={width} height={height} className={className}>
            <path
                fill={color}
                d="M2 9.653v7.632c0 .695.53 1.225 1.225 1.225h17.55c.695 0 1.225-.53 1.225-1.225V9.653H2zm20-3.429v2H2v-2C2 5.531 2.53 5 3.224 5h17.552C21.429 5 22 5.53 22 6.224"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { FidelityCard }
